import axiosRequest from "@/utils/axios-utils";
import axios from "axios";

// 03- ============= get Shipping Methods
export const emailSubscribe = async (handshake, email) => {
  let config = {
    method: "GET",
    maxBodyLength: Infinity,
    url: `/mstore/newsletter/subscribe/${email}`,
    headers: {
      Authorization: "Bearer " + handshake,
      admin: "Bearer " + process.env.NEXT_PUBLIC_MAGENTO_ADMIN_TOKEN,
    },
  };
  try {
    const req = await axiosRequest(config);

    return req;
  } catch (error) {
    return error;
  }
};

export const EMAIL_SUBSCIBE = async (email) => {
  try {
    const req = await axios.post("/api/subscibe", { email });
    return req?.data;
  } catch (error) {
    return error;
  }
};
